import React from 'react';
import PropTypes from 'prop-types';

const ArrowBack = ({width = '16px', height = '12px', color = '#FFFFFF'}) => (
  <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.707 5.293l-5-5a.999.999 0 1 0-1.414 1.414L12.586 5H1a1 1 0 1 0 0 2h11.586l-3.293 3.293a.999.999 0 1 0 1.414 1.414l5-5a.999.999 0 0 0 0-1.414"
      fill={color}
    />
  </svg>
);
ArrowBack.propTypes = {
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

export default ArrowBack;
